import * as S from './styles'

export const PreviewCardSkeleton = () => {
  return (
    <S.SkeletonContainer>
      <S.SkeletonLeftBox>
        <S.SkeletonLine width="80px" height="14px" />
        <S.SkeletonLine width="140px" height="24px" />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <S.SkeletonLine width="60px" height="12px" />
          <S.SkeletonLine width="100px" height="12px" />
        </div>
      </S.SkeletonLeftBox>
      <S.SkeletonIconBox>
        <S.SkeletonLine width="42px" height="42px" />
      </S.SkeletonIconBox>
    </S.SkeletonContainer>
  )
}
